<script>
export let login="";
export let senha="";
export let statusErro=0;
export let cadastrar=false;
import {createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();

function Cadastro(){
	cadastrar=true;
}
function ChamarEsquecerSenha(){
	dispatch("Chamar_Recuperar_Senha");
}
function ChamaTela(e){
	dispatch("ChamarTela",e)
}

</script>

<section>
<body class='back'>
<div class=" container ">
	<div class="d-flex justify-content-center h-100 ">
		<div class="card ">
			<div class="card-header">
				<h3>Login</h3>
				<!--
				<div class="d-flex justify-content-end social_icon">
					<span><i class="fab fa-facebook-square"></i></span>
					<span><i class="fab fa-google-plus-square"></i></span>
					<span><i class="fab fa-twitter-square"></i></span>
				</div>-->
			</div>
			<div class="card-body">
				<form >
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><img src="img/user.png" class="pl-1 logo-acesso" alt=""></span>
						</div>
						<input type="text" class="form-control" placeholder="Email" bind:value={login}>
						
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><img src="img/password.png" class="pl-1 logo-acesso" alt=""></span>
						</div>
						<input type="password" class="form-control" placeholder="Senha" bind:value={senha}>
					</div>
					<div class="row align-items-center remember">
                    {#if statusErro==2}
                    <span  class="tabular">Login ou senha inválidos</span>
					{:else if statusErro==3}
                    <span  class="tabular">Login não cadastrado</span>
					{:else if statusErro==4}
                    <span  class="tabular">Erro de comunicação</span>
                    {/if}
						<!--<input type="checkbox">Lembrar me-->
					</div>
					<div class="form-group">
					    {#if login=="" || senha==""}
                        <input type="submit" on:click|preventDefault  value="Login" disabled="true" class="btn float-right login_btn">
						{:else}
						<input type="submit" on:click|preventDefault  value="Login"  class="btn float-right login_btn">
						{/if}
					</div>
				</form>
			</div>
			
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					Não tem uma conta?<a href="#" on:click|preventDefault={(e)=>ChamaTela("cadastro")}>Cadastre-se</a>
				</div>
				<div class="d-flex justify-content-center">
					<a href="#" on:click|preventDefault={(e)=>ChamaTela("recuperarsenha")}>Esqueci a senha</a>
				</div>
			</div>
		</div>
	</div>
</div>


</body>

</section>


<style>
/* Bordered form */
/* Made with love by Mutiullah Samim*/

@import url('https://fonts.googleapis.com/css?family=Numans');
body{
    
    background-color: black}
.back{
background-image: url('../img/back.jpg');
background-size: cover;
background-repeat: no-repeat;

height: 100%;
padding: 10px;
font-family: 'Numans', sans-serif;

}

.container{
height: 100%;
align-content: center;
}

.card{
height: 370px;
margin-top:100px;
margin-bottom: 300px;
width: 400px;
background-color: rgba(0,0,0,0.5) !important;
}

.social_icon span{
font-size: 60px;
margin-left: 10px;
color: #FFC312;
}

.social_icon span:hover{
color: white;
cursor: pointer;
}

.card-header h3{
color: white;
}

.social_icon{
position: absolute;
right: 20px;
top: -45px;
}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}
.links a{
margin-left: 4px;
}
.tabular{
	margin-left:  20px;
}
.logo-acesso{
	height: 15px;
	align-content: center;
}
</style>